import Feature25_morph_right from './Feature25_morph_right'
export default Feature25_morph_right
